module.exports = __webpack_public_path__ + "img/light-skin-active-bg.f21e4f95.png";